import { render, staticRenderFns } from "./PackageHero.vue?vue&type=template&id=2c10bdc6&"
import script from "./PackageHero.vue?vue&type=script&lang=js&"
export * from "./PackageHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports